import { render, staticRenderFns } from "./Statics.vue?vue&type=template&id=6698b06e&"
import script from "./Statics.vue?vue&type=script&lang=js&"
export * from "./Statics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports